(async () => {

  if (!customElements.get('product-video')) {
    class ProductVideo extends HTMLElement {
      constructor() {
        super();

        this.videoControls();
      }

      videoControls() {
        const videoControls = this.querySelector('.video-controls');
        const play = videoControls.querySelector('[data-video-play]');
        const sound = videoControls.querySelector('[data-video-sound]');
        const video = this.querySelector('video');
        video.addEventListener('ended', this.togglePlay, false);
        play.addEventListener('click', this.togglePlay, false);
        sound.addEventListener('click', this.toggleSound, false);
      }

      togglePlay(e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.closest('.video-controls').classList.toggle('video-controls--pause');
        if (e.target.closest('.video-controls').classList.contains('video-controls--pause')) {
          e.target.closest('.product-media__item--video').querySelector('video').pause();
        } else {
          e.target.closest('.product-media__item--video').querySelector('video').play();
        }
      }

      toggleSound(e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.closest('.video-controls').classList.toggle('video-controls--sound');
        if (e.target.closest('.video-controls').classList.contains('video-controls--sound')) {
          e.target.closest('.product-media__item--video').querySelector('video').muted = false;
        } else {
          e.target.closest('.product-media__item--video').querySelector('video').muted = true;
        }
      }
    }

    window.ProductVideo = ProductVideo;
    customElements.define('product-video', ProductVideo);

  }

})();
